import { render } from "./StoreUsers.vue?vue&type=template&id=04fcd7a7"
import script from "./StoreUsers.vue?vue&type=script&lang=js"
export * from "./StoreUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__